import { render } from "./FracSupport.vue?vue&type=template&id=118bd7c6"
import script from "./FracSupport.vue?vue&type=script&lang=js"
export * from "./FracSupport.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ami-website\\www\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__